import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import './i18n';
import {Provider, useDispatch, useSelector} from 'react-redux'
import store from './redux/store'
import {FullPageLoader} from "./components/components";
import {useTranslation} from "react-i18next";
import { ToastContainer } from "./components/ToastContainer";
import Zones from './routes/admin/Zones';
import Dmps from './routes/admin/Dmps';
import Industries from './routes/admin/Industries';
import DataProducts from './routes/admin/DataProducts';
import DataVendors from './routes/admin/DataVendors';
import PakitoDashboard from './routes/admin/PakitoDashboard';
import Users from './routes/admin/Users';
import Publishers from './routes/admin/Publishers';
import PageElements from './routes/admin/PageElements';
import Devices from './routes/admin/Devices';
import Apps from './routes/admin/Apps';
import Finance from './routes/admin/Finance';
import GeocodeTool from './components/GeocodeTool';
import AdminDashboard from './pages/admin/AdminDashboard';
import Searchbar from './components/Searchbar';
import { setNavbarSmall } from './redux/layoutSlice';
import Navigation from './components/navigation/Navigation';
import Navitem from './components/navigation/Navitem';
import NavitemGroup from './components/navigation/NavitemGroup';
import Documentation from './pages/admin/sdk/Documentation';
import Configuration from './pages/admin/sdk/Configuration';
import CmpDefaultConfiguration from './pages/admin/cmp/CmpDefaultConfiguration';
import CmpAnalytics from './pages/admin/cmp/CmpAnalytics';
import ConsentRequestLayouts from './pages/admin/cmp/ConsentRequestLayouts';
import NoMenuRoute from './components/navigation/NoMenuRoute';
import RemoteConfiguration from './pages/admin/sdk/RemoteConfiguration';
import SdkVersion from './routes/admin/SdkVersion';
import OauthPublisherApplication from './components/oauth/OauthPublisherApplication';
import get from 'lodash/get';
import { useGetCurrentUserQuery } from './api/userApiSlice';
import MotionModels from './pages/admin/motion_models/MotionModels';

function Admin(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navbarSmall = useSelector(state => state.layout.navbarSmall)
  const { data: currentUser = {}, isSuccess: isCurrentUserSuccess } = useGetCurrentUserQuery()

  const toggleNavbar = () => dispatch(setNavbarSmall(!navbarSmall))

  if (!isCurrentUserSuccess) {
    return <>
      <div className="background-container"/>
      <FullPageLoader/>
    </>
  }

  return (
    <Router>
      <div className="background-container"/>
      <FullPageLoader/>
      <ToastContainer/>
      <div className={navbarSmall ? 'nav-sm' : 'nav-md'}>
        <Suspense fallback={<div>{t('loading')}...</div>}>
          <Searchbar handleOnClick={toggleNavbar} />
          <Navigation>
            <Navitem exact path="/" icon='home' text={t('menu.dashboard')} component={AdminDashboard}/>
            { get(currentUser, 'menuAccess.users', false) && <Navitem path="/users" icon='users' text={t('menu.users')} component={Users}/> }
            { get(currentUser, 'menuAccess.publishers', false) && <Navitem path="/publishers" icon='publishers' text={t('menu.publishers')} component={Publishers}/> }
            <NavitemGroup icon='database' text= {'Difacto'}>
              {get(currentUser, 'menuAccess.dataVendors', false) && <Navitem path="/data_vendors" text={t('menu.data_vendors')} component={DataVendors}/>}
              {get(currentUser, 'menuAccess.dataProducts', false) && <Navitem path="/data_products" text={t('menu.data_products')} component={DataProducts}/>}
              {get(currentUser, 'menuAccess.zones', false) && <Navitem path="/zones" text={t('menu.zones')} component={Zones}/>}
              {get(currentUser, 'menuAccess.industries', false) && <Navitem path="/industries" text={t('menu.industries')} component={Industries}/>}
              {get(currentUser, 'menuAccess.dmps', false) && <Navitem path="/dmps" text={t('menu.dmps')} component={Dmps}/>}
            </NavitemGroup>
            { get(currentUser, 'menuAccess.pakito', false) && <Navitem path="/pakito" icon='pakito' text={'Pakito'} component={PakitoDashboard}/> }
            <NavitemGroup icon='code' text= {'Sdk'}>
              {get(currentUser, 'menuAccess.documents', false) && <Navitem path="/sdk/documentation" text={t('menu.documentation')} component={Documentation}/>}
              {get(currentUser, 'menuAccess.sdkConfigs', false) &&  <Navitem path="/sdk/configurations" text={t('menu.configuration')} component={Configuration}/>}
              {get(currentUser, 'menuAccess.sdkVersions', false) && <Navitem path="/sdk/sdk_versions" text={t('menu.sdk_version')} component={SdkVersion}/>}
              {get(currentUser, 'menuAccess.sdkRemoteConfigurations', false) && <Navitem path="/sdk/remote_parameters" text={t('menu.remote_parameter')} component={RemoteConfiguration}/>}
            </NavitemGroup>
            <NavitemGroup icon='consent' text= {'Cmp'}>
              {get(currentUser, 'menuAccess.cmpConfigs', false) && <Navitem path="/cmp/configuration" text={t('menu.cmp_configuration')} component={CmpDefaultConfiguration}/>}
              {get(currentUser, 'menuAccess.cmpAnalytics', false) && <Navitem path="/cmp/analytics" text={t('menu.cmp_analytics')} component={CmpAnalytics}/>}
              {get(currentUser, 'menuAccess.cmpLayouts', false) && <Navitem path="/cmp/consent_request_layouts" text={t('menu.cmp_consent_request_layouts')} component={ConsentRequestLayouts}/>}
            </NavitemGroup>
            { get(currentUser, 'menuAccess.invoices', false) && <Navitem path="/finance" icon='revenue' text={t('menu.finance')} component={Finance}/> }
            { get(currentUser, 'menuAccess.devices', false) && <Navitem path="/devices" icon='mobile' text={t('menu.devices')} component={Devices}/> }
            { get(currentUser, 'menuAccess.dev', false) &&
            <NavitemGroup icon='wrench' text= {t('menu.dev')}>
              <Navitem path="/geocode_tools" text={t('menu.geocode_tools')} component={GeocodeTool}/>
              <Navitem path="/page_elements" text={t('menu.page_elements')} component={PageElements}/>
              <Navitem path="/motion_models" text={t('menu.motion_models')} component={MotionModels}/>
            </NavitemGroup> }
            { get(currentUser, 'menuAccess.oauthApps', false) &&
            <NavitemGroup icon='service' text= {t('menu.services')}>
              <Navitem path="/applications" text={t('menu.applications')} component={OauthPublisherApplication}/>
            </NavitemGroup> }
            <NoMenuRoute path="/apps" component={Apps} />
          </Navigation>
        </Suspense>
      </div>
    </Router>
  )
}

document.addEventListener('turbo:load', () => {
  const app = document.getElementById('admin-app');
  if(app) {
    ReactDOM.render(
      <Provider store={store}>
        <Admin />
      </Provider>,
      app
    );
  }
})
